import { ExecutionCardProps } from "../../components/executionCard/types";
import { QualificationCardProps } from "../../components/qualificationCard/types";
import { HeaderState } from "../../types";
import { TFunction } from "react-i18next";
import dayjs from "dayjs";

const formatNoResponse = ({ t }: { t: TFunction<"translation", undefined> }) => {
    const noHeader: HeaderState = {
        averagePoints: 0,
        dataHeader: {
            "quest_name": "N/A",
            "description": "",
            "instruction": "",
            "areas": {
                label: "",
                value: 0,
                id: ''
            },
            "departments": {
                label: "",
                value: 0,
                id: ''
            },
            totalSection: 0,
            "totalPoints": '0',
            "option": false,
            statusId: '',
        },
        isSectionConfig: false
    }

    const noConfig: Array<(ExecutionCardProps | QualificationCardProps)> = [
        { qualification: 0, total: 0 },
        { options: [{ text: t('Questionarie.cards.sectionss'), number: 0 }, { text: t('Questionarie.cards.questions'), number: 0 }, { text: t('Questionarie.cards.totalPoints'), number: 0 }] },
        {
            percentage: true,
            options: [
                { text: t('Questionarie.cards.scheduled'), number: 0 },
                { text: t('Questionarie.cards.completed'), number: 0, percentage: 0 },
                { text: t('Questionarie.cards.notCompleted'), number: 0, percentage: 0 }
            ]
        },
        {
            percentage: true,
            title: t('Questionarie.actionPlan'),
            options: [
                { text: t('Questionarie.cards.generated'), number: 0 },
                { text: t('Questionarie.cards.approved'), number: 0, percentage: 0 },
                { text: t('Questionarie.cards.rejected'), number: 0, percentage: 0 }
            ]
        },
        {
            percentage: true,
            title: t('Questionarie.reportFolio'),
            options: [
                { text: t('Questionarie.cards.generated'), number: 0 },
                { text: t('Questionarie.cards.approved'), number: 0, percentage: 0 },
                { text: t('Questionarie.cards.rejected'), number: 0, percentage: 0 }
            ]
        }
    ]

    const noHeaderConfig: { created: string, date?: dayjs.Dayjs } = {
        created: '',
        date: undefined
    }

    return {
        noHeader,
        noConfig,
        noHeaderConfig
    }
}


export { formatNoResponse }